module.exports = __webpack_public_path__ + "nf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/nf.svg
// module id = 728
// module chunks = 0